import React, { useState, useEffect } from "react";
import { Button, Modal, Table, Image, Spinner } from "react-bootstrap";
import { AiFillDelete } from "react-icons/ai";
import { BiSolidEdit } from "react-icons/bi";
import { BsSearch } from "react-icons/bs";
import axios from "axios";

const BASE_URL = "https://dailydish.in/api";

const KarleAddProducts = () => {
  const [products, setProducts] = useState([]);
  const [noChangeData, setNoChangeData] = useState([]);
  const [cookableItems, setCookableItems] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Add modal
  const [showAdd, setShowAdd] = useState(false);
  // Edit modal
  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState({});
  // Delete modal
  const [showDelete, setShowDelete] = useState(false);
  const [delData, setDelData] = useState("");
  // Image preview modal
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const [foodName, setFoodName] = useState("");
  const [foodImage, setFoodImage] = useState("");
  const [karlePrice, setKarlePrice] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [components, setComponents] = useState([]);

  const resetForm = () => {
    setFoodName("");
    setFoodImage("");
    setKarlePrice("");
    setShortDescription("");
    setComponents([]);
  };

  const getProducts = async () => {
    try {
      setIsDataLoading(true);
      const res = await axios.get(`${BASE_URL}/karle/products/getProducts`);
      if (res.data.success) {
        setProducts(res.data.data);
        setNoChangeData(res.data.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsDataLoading(false);
    }
  };

  const fetchCookableItems = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/production/cookable-items`);
      if (res.data.success) setCookableItems(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getProducts();
    fetchCookableItems();
  }, []);

  const handleShowAdd = () => {
    resetForm();
    setShowAdd(true);
  };
  const handleCloseAdd = () => setShowAdd(false);

  const handleShowEdit = (item) => {
    setEditData(item);
    setFoodName(item?.foodName || "");
    setFoodImage("");
    setKarlePrice(item?.karlePrice || "");
    setShortDescription(item?.shortDescription || "");
    setComponents(
      (item?.components || []).map((c) => ({
        cookableItemId:
          typeof c.cookableItemId === "object"
            ? String(c.cookableItemId._id)
            : String(c.cookableItemId || ""),
        qty: c.qty || "",
        search:
          typeof c.cookableItemId === "object"
            ? c.cookableItemId?.name || ""
            : "",
      })),
    );
    setShowEdit(true);
  };
  const handleCloseEdit = () => setShowEdit(false);

  const handleShowDelete = (item) => {
    setDelData(item);
    setShowDelete(true);
  };
  const handleCloseDelete = () => setShowDelete(false);

  const handleShowImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const addProduct = async () => {
    try {
      if (!foodName) return alert("Please add food name");
      if (!karlePrice) return alert("Please add Karle price");
      if (!foodImage) return alert("Please add food image");

      const formdata = new FormData();
      formdata.append("foodName", foodName);
      formdata.append("foodImage", foodImage);
      formdata.append("karlePrice", karlePrice);
      formdata.append("shortDescription", shortDescription);
      formdata.append(
        "components",
        JSON.stringify(components.filter((c) => c.cookableItemId && c.qty)),
      );

      setIsLoading(true);
      const res = await axios.post(
        `${BASE_URL}/karle/products/addProduct`,
        formdata,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
      if (res.status === 200) {
        alert("Karle product added successfully");
        handleCloseAdd();
        resetForm();
        await getProducts();
      }
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.error || "Error adding product");
    } finally {
      setIsLoading(false);
    }
  };

  const updateProduct = async () => {
    try {
      if (!foodName) return alert("Please add food name");
      if (!karlePrice) return alert("Please add Karle price");

      const formdata = new FormData();
      formdata.append("id", editData._id);
      formdata.append("foodName", foodName);
      if (foodImage) formdata.append("foodImage", foodImage);
      formdata.append("karlePrice", karlePrice);
      formdata.append("shortDescription", shortDescription);
      formdata.append(
        "components",
        JSON.stringify(components.filter((c) => c.cookableItemId && c.qty)),
      );

      setIsLoading(true);
      const res = await axios.put(
        `${BASE_URL}/karle/products/updateProduct`,
        formdata,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
      if (res.status === 200) {
        alert("Updated successfully");
        handleCloseEdit();
        await getProducts();
      }
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.error || "Error updating product");
    } finally {
      setIsLoading(false);
    }
  };

  const deleteProduct = async () => {
    try {
      setIsLoading(true);
      const res = await axios.delete(
        `${BASE_URL}/karle/products/deleteProduct/${delData._id}`,
      );
      if (res.status === 200) {
        alert("Deleted successfully");
        handleCloseDelete();
        await getProducts();
      }
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.error || "Error deleting product");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    if (term !== "") {
      setProducts(
        noChangeData.filter((p) => p.foodName?.toLowerCase().includes(term)),
      );
    } else {
      setProducts(noChangeData);
    }
  };

  const renderComponentPicker = (isEditMode) => (
    <div className="row">
      <div className="do-sear mt-2">
        <label>Cookable Items</label>
        {components.map((comp, i) => {
          const selectedCI = cookableItems.find(
            (ci) => ci._id === comp.cookableItemId,
          );
          const filteredCI = cookableItems.filter((ci) =>
            ci.name.toLowerCase().includes((comp.search || "").toLowerCase()),
          );
          const showDrop = !!(comp.search && !comp.cookableItemId);
          return (
            <div
              key={i}
              style={{
                display: "flex",
                gap: 6,
                marginBottom: 8,
                alignItems: "flex-start",
              }}
            >
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="text"
                  placeholder="Search cookable item..."
                  value={comp.search || ""}
                  onChange={(e) =>
                    setComponents((prev) =>
                      prev.map((c, idx) =>
                        idx === i
                          ? { ...c, search: e.target.value, cookableItemId: "" }
                          : c,
                      ),
                    )
                  }
                  className="form-control"
                  style={{ fontSize: 13 }}
                  autoComplete="off"
                />
                {comp.cookableItemId && (
                  <span
                    style={{
                      position: "absolute",
                      right: 32,
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: 11,
                      color: "#1D9E75",
                      fontWeight: 600,
                    }}
                  >
                    ✓
                  </span>
                )}
                {comp.cookableItemId && (
                  <button
                    type="button"
                    onClick={() =>
                      setComponents((prev) =>
                        prev.map((c, idx) =>
                          idx === i
                            ? { ...c, cookableItemId: "", search: "" }
                            : c,
                        ),
                      )
                    }
                    style={{
                      position: "absolute",
                      right: 8,
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "none",
                      border: "none",
                      color: "#aaa",
                      cursor: "pointer",
                      fontSize: 14,
                      padding: 0,
                    }}
                  >
                    ✕
                  </button>
                )}
                {showDrop && (
                  <div
                    style={{
                      position: "absolute",
                      top: "calc(100% + 2px)",
                      left: 0,
                      right: 0,
                      zIndex: 1060,
                      background: "#fff",
                      border: "1px solid #ddd",
                      borderRadius: 8,
                      boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
                      maxHeight: 160,
                      overflowY: "auto",
                    }}
                  >
                    {filteredCI.length === 0 ? (
                      <div
                        style={{
                          padding: "10px 14px",
                          color: "#aaa",
                          fontSize: 13,
                        }}
                      >
                        No items found
                      </div>
                    ) : (
                      filteredCI.map((ci) => (
                        <div
                          key={ci._id}
                          onMouseDown={() =>
                            setComponents((prev) =>
                              prev.map((c, idx) =>
                                idx === i
                                  ? {
                                      ...c,
                                      cookableItemId: ci._id,
                                      search: ci.name,
                                    }
                                  : c,
                              ),
                            )
                          }
                          style={{
                            padding: "8px 14px",
                            cursor: "pointer",
                            fontSize: 13,
                            borderBottom: "1px solid #f5f5f5",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f8f9fa")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "")
                          }
                        >
                          {ci.name}{" "}
                          <span style={{ fontSize: 11, color: "#aaa" }}>
                            ({ci.outputType})
                          </span>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
              <input
                type="number"
                min="0"
                step="0.01"
                placeholder="Qty"
                value={comp.qty}
                onChange={(e) =>
                  setComponents((prev) =>
                    prev.map((c, idx) =>
                      idx === i ? { ...c, qty: e.target.value } : c,
                    ),
                  )
                }
                style={{ width: 75, fontSize: 13 }}
                className="form-control"
              />
              <span
                style={{
                  fontSize: 11,
                  color: "#888",
                  width: 26,
                  paddingTop: 8,
                  textAlign: "center",
                }}
              >
                {selectedCI?.outputType === "weight"
                  ? "kg"
                  : selectedCI?.outputType === "pieces"
                    ? "pcs"
                    : selectedCI?.outputType === "pack"
                      ? "pk"
                      : ""}
              </span>
              <button
                type="button"
                onClick={() =>
                  setComponents((prev) => prev.filter((_, idx) => idx !== i))
                }
                style={{
                  background: "#FCEBEB",
                  border: "none",
                  borderRadius: "50%",
                  width: 28,
                  height: 28,
                  color: "#A32D2D",
                  cursor: "pointer",
                  fontSize: 14,
                  marginTop: 1,
                }}
              >
                ✕
              </button>
            </div>
          );
        })}
        <button
          type="button"
          className="btn btn-sm btn-outline-success mt-1"
          onClick={() =>
            setComponents((prev) => [
              ...prev,
              { cookableItemId: "", qty: "", search: "" },
            ])
          }
        >
          + Add component
        </button>
      </div>
    </div>
  );

  return (
    <div>
      <div className="customerhead p-2">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="col-lg-4 d-flex justify-content-center">
            <div className="input-group">
              <span className="input-group-text">
                <BsSearch />
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                onChange={handleSearch}
              />
            </div>
          </div>
          <Button variant="success" onClick={handleShowAdd}>
            + ADD
          </Button>
        </div>

        {isDataLoading ? (
          <div className="text-center my-5">
            <Spinner animation="border" variant="oranged" />
            <p>Loading Karle products...</p>
          </div>
        ) : (
          <Table
            responsive
            bordered
            style={{ width: "-webkit-fill-available" }}
          >
            <thead>
              <tr>
                <th>Sl. No</th>
                <th>Image</th>
                <th>Food Name</th>
                <th>Karle Price</th>
                <th>Short Description</th>
                <th>Cookable Items</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {products.map((item, i) => (
                <tr key={item._id}>
                  <td>{i + 1}</td>
                  <td>
                    <div style={{ cursor: "pointer" }}>
                      <img
                        src={item.foodImage}
                        alt="img"
                        style={{ width: "60px", height: "60px" }}
                        onClick={() => handleShowImageModal(item.foodImage)}
                      />
                    </div>
                  </td>
                  <td>{item.foodName}</td>
                  <td>{item.karlePrice}</td>
                  <td>{item.shortDescription}</td>
                  <td style={{ fontSize: "0.75rem" }}>
                    {item.components?.length > 0 ? (
                      item.components.map((c, ci) => {
                        const name =
                          typeof c.cookableItemId === "object"
                            ? c.cookableItemId?.name
                            : null;
                        if (!name) return null;
                        return (
                          <span
                            key={ci}
                            style={{
                              display: "inline-block",
                              marginRight: 4,
                              marginBottom: 3,
                              padding: "2px 7px",
                              background: "#e8f4d4",
                              borderRadius: 10,
                              color: "#3a5a0e",
                              fontWeight: 500,
                            }}
                          >
                            {name} {c.qty}
                          </span>
                        );
                      })
                    ) : (
                      <span style={{ color: "#bbb" }}>—</span>
                    )}
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "20px",
                        justifyContent: "center",
                      }}
                    >
                      <BiSolidEdit
                        className="text-success"
                        style={{ cursor: "pointer", fontSize: "20px" }}
                        onClick={() => handleShowEdit(item)}
                      />
                      <AiFillDelete
                        className="text-danger"
                        style={{ cursor: "pointer", fontSize: "20px" }}
                        onClick={() => handleShowDelete(item)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
              {products.length === 0 && (
                <tr>
                  <td colSpan={7}>No Karle products yet</td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </div>

      {/* Add modal */}
      <Modal show={showAdd} onHide={handleCloseAdd} style={{ zIndex: "99999" }}>
        <Modal.Header closeButton>
          <Modal.Title>Add Karle Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="do-sear mt-2">
              <label>Food Name</label>
              <input
                type="text"
                className="vi_0"
                placeholder="Enter Food Name"
                value={foodName}
                onChange={(e) => setFoodName(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="do-sear mt-2">
              <label>Food Image</label>
              <input
                type="file"
                className="vi_0"
                onChange={(e) => setFoodImage(e.target.files[0])}
              />
            </div>
          </div>
          <div className="row">
            <div className="do-sear mt-2">
              <label>Karle Price</label>
              <input
                type="number"
                className="vi_0"
                min={0}
                placeholder="Enter Karle Price"
                value={karlePrice}
                onChange={(e) => setKarlePrice(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="do-sear mt-2">
              <label>Short Description</label>
              <input
                type="text"
                className="vi_0"
                placeholder="Enter Short Description"
                value={shortDescription}
                onChange={(e) => setShortDescription(e.target.value)}
              />
            </div>
          </div>
          {renderComponentPicker(false)}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="modal-close-btn"
            variant=""
            onClick={handleCloseAdd}
            disabled={isLoading}
          >
            Close
          </Button>
          <Button
            className="modal-add-btn"
            variant=""
            onClick={addProduct}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span className="ms-2">Adding...</span>
              </>
            ) : (
              "Add"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit modal */}
      <Modal
        show={showEdit}
        onHide={handleCloseEdit}
        style={{ zIndex: "99999" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Karle Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="do-sear mt-2">
              <label>Food Name</label>
              <input
                type="text"
                className="vi_0"
                value={foodName}
                onChange={(e) => setFoodName(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="do-sear mt-2">
              <label>Food Image</label>
              <input
                type="file"
                className="vi_0"
                onChange={(e) => setFoodImage(e.target.files[0])}
              />
            </div>
          </div>
          <div className="row">
            <div className="do-sear mt-2">
              <label>Karle Price</label>
              <input
                type="number"
                className="vi_0"
                value={karlePrice}
                onChange={(e) => setKarlePrice(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="do-sear mt-2">
              <label>Short Description</label>
              <input
                type="text"
                className="vi_0"
                value={shortDescription}
                onChange={(e) => setShortDescription(e.target.value)}
              />
            </div>
          </div>
          {renderComponentPicker(true)}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="modal-close-btn"
            variant=""
            onClick={handleCloseEdit}
            disabled={isLoading}
          >
            Close
          </Button>
          <Button
            className="modal-add-btn"
            variant=""
            onClick={updateProduct}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span className="ms-2">Updating...</span>
              </>
            ) : (
              "Update"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete modal */}
      <Modal
        show={showDelete}
        onHide={handleCloseDelete}
        style={{ zIndex: "99999" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fs-4" style={{ color: "red" }}>
            Are you sure?
            <br /> you want to delete this Karle product?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="modal-close-btn"
            variant=""
            onClick={handleCloseDelete}
            disabled={isLoading}
          >
            Close
          </Button>
          <Button
            className="modal-add-btn"
            variant=""
            onClick={deleteProduct}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span className="ms-2">Deleting...</span>
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Image preview modal */}
      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        centered
        size="lg"
        style={{ zIndex: "99999" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Product Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <Image
              src={selectedImage}
              alt="Preview"
              fluid
              style={{ maxHeight: "500px", width: "auto", maxWidth: "100%" }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowImageModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default KarleAddProducts;
